export default __webpack_public_path__ + "static/media/interviews.d6b93500.png";